import { h, Component } from "preact";
import { gettext as _ } from "../../utils/i18n";

export default class ActionBar extends Component {
    constructor(props) {
        super(props);

        this.element = document.querySelector(this.props.target);

        this.state = {
            visible: false,
        };
    }

    show(e) {
        this.setState(
            {
                visible: true,
            },
            () => {
                this.element.classList.remove("readmore-hidden");
                this.element.classList.add("readmore-visible");
            }
        );

        e.preventDefault();
    }

    render(props, state) {
        if (state.visible) {
            return null;
        }

        // do not show readme when content is not overflowing
        if (this.element.offsetWidth == 0 || this.element.offsetHeight >= this.element.scrollHeight) {
            return null;
        }

        var msg_read_more = _("Read more");
        return (
            <a href="" onclick={(e) => this.show(e)}>
                {msg_read_more}
            </a>
        );
    }
}
